import { toast } from 'react-toastify'
const download = async (fileUrl: string) => {
  const proxyUrl = `${process.env.APP_BASE_URL}/proxy?url=${encodeURIComponent(fileUrl)}`
  await fetch(proxyUrl, {
    method: 'GET',
    headers: {
      'Api-Key': process.env.API_KEY,
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileUrl.split('/').pop()
      a.click()
      URL.revokeObjectURL(url)
    })
    .catch(() => {
      toast.error('Failed to download')
    })
}

export default download
